import { render, staticRenderFns } from "./CompanyAwayDetailModal.vue?vue&type=template&id=4830eac8&scoped=true&"
import script from "./CompanyAwayDetailModal.vue?vue&type=script&lang=js&"
export * from "./CompanyAwayDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4830eac8",
  null
  
)

export default component.exports